import { Injectable, Injector } from '@angular/core'
import { Router } from '@angular/router'
import { Apollo, gql } from 'apollo-angular'
import { PageComponent } from '../page/page.component'
import { PageGuard } from '../page/page.component.guard'
import { HomeGuard } from '../page/page.home.component.guard'

@Injectable()
export class SettingsService {
  constructor(private injector: Injector, private apollo: Apollo) {}

  async loadSettings(): Promise<void> {
    return new Promise((resolve, reject) => {
      const router = this.injector.get(Router)

      this.apollo
        .watchQuery({
          query: gql`
            {
              allPages {
                _allSlugLocales {
                  locale
                  value
                }
              }
            }
          `,
        })
        .valueChanges.subscribe((result: any) => {
          const { data } = result
          const { allPages } = data

          allPages.forEach((page, i) => {
            const { _allSlugLocales: locales } = page
            locales.forEach((l) => {
              const { locale, value } = l

              if (i === 0) {
                router.config.push({
                  path: `${locale}/${value}`,
                  redirectTo: `${locale}`,
                })

                return
              }

              router.config.push({
                path: `:lang/${value}`,
                component: PageComponent,
              })
            })
          })

          resolve()
        })
    })
  }
}
